import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: { offset: -80 } });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  return null;
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
      }, 150);
      return () => clearTimeout(t);
    }
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <div className="grain" aria-hidden="true" />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
        <Footer />
        <CartDrawer />
        <Toaster position="bottom-left" toastOptions={{ descriptionClassName: "!text-[#c9bfb2]", style: { background: "#1C1915", color: "#EFE9DF", border: "none", borderRadius: 2 } }} />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
